import { render, staticRenderFns } from "./PhoneHome.vue?vue&type=template&id=2f990efc&scoped=true&"
import script from "./PhoneHome.vue?vue&type=script&lang=js&"
export * from "./PhoneHome.vue?vue&type=script&lang=js&"
import style0 from "./PhoneHome.vue?vue&type=style&index=0&id=2f990efc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f990efc",
  null
  
)

export default component.exports